import React from 'react';
const Unauthorized = () => {
    return ( <div>
        <h2>Sin permiso</h2>
    </div> );
}
 
export default Unauthorized;